import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../backend";
import authHeader from "../../services/auth-header";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import { useSubscriptionFeatures } from "../../contexts/SubscriptionContext";

function ApprovalAction({ request, onSuccess }) {
    const { planFeatures } = useSubscriptionFeatures();
    console.log("request 👉", request);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [comment, setComment] = useState("");
    const [actionType, setActionType] = useState("submit");
    const status = request?.status?.toLowerCase();

    const isDraft = status === "draft";
    const isPending = status === "pending";

    useEffect(() => {
        axios.get(API + "approvals/users/", {
            headers: authHeader()
        }).then(res => setUsers(res.data || []));
    }, []);

    useEffect(() => {
        if (actionType !== "reassign" && actionType !== "submit") {
            setSelectedUser(null);
        }
    }, [actionType]);

        const isApprovalDisabled = planFeatures !== null && planFeatures.approvals === false;

    useEffect(() => {
        if (request?.status === "Draft") {
            setActionType("submit");
        } else if (request?.status === "Pending") {
            setActionType("approve");
        }
    }, [request]);

    const handleSave = async () => {
        try {

            // SUBMIT FOR APPROVAL
            if (actionType === "submit") {

                if (!selectedUser) {
                    toast.error("Please select user");
                    return;
                }

                let url = "";

                const path = window.location.pathname;

                const isManual = path.includes("manual");
                const isExpense = path.includes("expenses");
                const isInvoice = path.includes("billing");
                const isReceipt = path.includes("receipts");
                const isContract = path.includes("contract")

                if (isManual) {
                    url = `manualaccounting/${request.id}/submit-approval/`;
                }
                else if (isExpense) {
                    url = `expenses/${request.id}/submit-approval/`;
                }
                else if (isInvoice) {
                    url = `billing/invoice/submit-approval/${request.id}/`;
                }
                else if (isReceipt) {
                    url = `receipts/submit-approval/${request.id}/`;
                }
                else if (isContract) {
                    url = `contracts/contracts/submit-approval/${request.id}/`;
                }
                else if (path.includes("creditmemo")) {
                    url = `creditmemo/${request.id}/submit-approval/`;
                }

                await axios.post(
                    API + url,
                    {
                        user: selectedUser,
                        comment: comment || ""
                    },
                    { headers: authHeader() }
                );

                toast.success("Submitted for approval");
            }

            // APPROVE
            else if (actionType === "approve") {
                await axios.post(
                    API + `approvals/approve/${request.id}/`,
                    { comment },
                    { headers: authHeader() }
                );

                toast.success("Approved");
            }

            // REJECT
            else if (actionType === "reject") {
                await axios.post(
                    API + `approvals/reject/${request.id}/`,
                    { comment },
                    { headers: authHeader() }
                );

                toast.success("Rejected");
            }

            // REASSIGN
            else if (actionType === "reassign") {

                if (!selectedUser) {
                    toast.error("Please select a user");
                    return;
                }

                await axios.post(
                    API + `approvals/reassign/${request.id}/`,
                    {
                        user: selectedUser,
                        comment
                    },
                    { headers: authHeader() }
                );

                toast.success("Reassigned");
            }

            onSuccess && onSuccess(actionType);

        } catch (err) {
            console.error(err);
            toast.error("Action failed");
        }
    };

    if (!request) return null;

    return (
        <div className="card">
            {!isApprovalDisabled && (
            <div className="card-body">

                <ToastContainer />

                <h5 className="mb-3">Approval Action</h5>

                {/* ACTION TYPE */}
                <div className="mb-3">
                    <label className="col-form-label">Action</label>
                    <select
                        className="form-control"
                        value={actionType}
                        onChange={(e) => setActionType(e.target.value)}
                    >
                        {isDraft && (
                            <option value="submit">Submit For Approval</option>
                        )}

                        {isPending && (
                            <>
                                <option value="approve">Approve</option>
                                <option value="reject">Reject</option>
                                <option value="reassign">Reassign</option>
                            </>
                        )}
                    </select>
                </div>

                {/* REASSIGN */}
                {["reassign", "submit"].includes(actionType) && (
                    <div className="mb-3">
                        <label className="col-form-label">Assign To</label>
                        <Select
                            options={users.map(u => ({
                                value: u.id,
                                label: u.username
                            }))}
                            onChange={(opt) => setSelectedUser(opt?.value)}
                        />
                    </div>
                )}

                {/* COMMENT */}
                <div className="mb-3">
                    <label className="col-form-label">Comment</label>
                    <textarea
                        className="form-control"
                        rows="3"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    />
                </div>

                {/* BUTTONS */}
                <button className="btn btn-primary" onClick={handleSave}>
                    {actionType === "submit" ? "Submit" : "Save"}
                </button>

            </div>
            )}
        </div>
    );
}

export default ApprovalAction;